import React from 'react';
import { URL } from '@Pages/url';
import s from '../styles/News.module.css';
import Heading1 from '@Components/heading_1/view';
import Heading2 from '@Components/heading_2/view';

type NewsContent = {
    id: number;
    title: string;
    date: string;
};

type NewsListWithTitleProps = {
    title: string;
    isStaffBlog: boolean;
    contents: NewsContent[];
    courseId?: string;
};

const NewsListWithTitle = (props: NewsListWithTitleProps) => {
    if (!props.contents || !props.contents.length) return null;

    const path = props.isStaffBlog ? URL.INFO_STAFF_BLOG : URL.INFO_GOLF;
    const HeadingComponent = props.isStaffBlog ? <Heading1 title={props.title} /> : <Heading2 title={props.title} />;

    const displayContents = props.contents.slice(0, 5);
    const hasContents = props.contents.length > 0;

    const moreLink =
        props.isStaffBlog && props.courseId
            ? `${URL.INFO_STAFF_BLOG}?course_id=${props.courseId}`
            : URL.INFO_STAFF_BLOG;

    return (
        <div className={s.list_container}>
            {HeadingComponent}
            <div className={s.news_items}>
                {displayContents.map((news) => {
                    const newsPath = `${path}/${news.id}`;

                    return (
                        <p className={s.news_item} key={news.id}>
                            <span className={s.news_date}>{news.date}</span>
                            <a className={s.news_title} href={newsPath}>
                                {news.title}
                            </a>
                        </p>
                    );
                })}
            </div>
            {hasContents && props.isStaffBlog && (
                <div className={s.link}>
                    <a href={moreLink}>スタッフブログをもっと見る</a>
                </div>
            )}
        </div>
    );
};

export default NewsListWithTitle;
